import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CreateChatResponse } from '@/types/tech-qa/tech-qa';

export interface SuperAgentApi {
  conversational(conversation_id: string, image_ids: string[]): Promise<Record<any, any>>;
  uploadImage(file: File): Promise<Record<any, any>>;
}

export const SuperAgentApi = Symbol('SuperAgentApi');

@injectable()
export class SuperAgentApiImpl extends PsHttpService implements SuperAgentApi {
  get options() {
    return {
      baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/api/eureka`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  conversational(query: string, image_ids: string[]): Promise<Record<any, any>> {
    return this.post<PatSnapCommonResponseData<CreateChatResponse>>({
      baseURL: this.options.baseURL,
      url: '/query/conversational',
      data: {
        query,
        file_ids: [],
        image_ids,
        skill_list: [],
        work_project: '',
      },
    }).then((res) => {
      return res;
    });
  }

  uploadImage(file: File): Promise<Record<any, any>> {
    const formData = new FormData();
    formData.append('file', file);

    return this.post<PatSnapCommonResponseData<Record<any, any>>>({
      baseURL: this.options.baseURL,
      url: '/image/upload',
      data: formData,
    }).then((res) => {
      return res.data;
    });
  }
}
